export default "__VITE_ASSET__6590d6af__"